import {warnAndRedirectAfterInaccessiblePageOpen} from 'auth/capabilities/InaccessibleFeaturesActions';
import BenchlingConfig from 'BenchlingConfig';
import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';
import EntityStore from 'stores/EntityStore';

export const ChemistryRoutes: RouteBundle = {
  domain: 'chemistry',
  routes: [
    // Both legacy listing routes render the single merged Salt & Solvate library so existing
    // bookmarks and deep links keep working.
    {
      urlPattern: 'salts/listing',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        EditorRoutes.saltSolvateLibrary();
      },
    },
    {
      urlPattern: 'solvents/listing',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        EditorRoutes.saltSolvateLibrary();
      },
    },
    // CSV import always creates salts, so both legacy CSV routes render the same import page.
    {
      urlPattern: 'salts/create/bulk-csv',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        if (!EntityStore.currentUser()?.isTenantAdmin) {
          warnAndRedirectAfterInaccessiblePageOpen(
            'You must be a tenant admin to import salts and solvates. Please contact your tenant admin for more information.'
          );
          return;
        }
        EditorRoutes.saltSolvateCreateFromCSVPage();
      },
    },
    {
      urlPattern: 'solvents/create/bulk-csv',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        if (!EntityStore.currentUser()?.isTenantAdmin) {
          warnAndRedirectAfterInaccessiblePageOpen(
            'You must be a tenant admin to import salts and solvates. Please contact your tenant admin for more information.'
          );
          return;
        }
        EditorRoutes.saltSolvateCreateFromCSVPage();
      },
    },
  ],
};
